import { PeekAccordion, PeekAccordionDetails, PeekAccordionSummary, PeekGrid, PeekStack, PeekTypography, useTheme, } from "@piiqtechnologies/ui-components";
import React from "react";
const AccordionItem = ({ title, subTitle, expanded, actionIcon, onChange, children, disabled, }) => {
    const theme = useTheme();
    return (React.createElement(PeekAccordion, { expanded: expanded, onChange: onChange, disabled: disabled },
        React.createElement(PeekAccordionSummary, { "aria-controls": `${title}-content`, id: `${title}-header`, sx: { borderRadius: 2, border: 0 } },
            React.createElement(PeekGrid, { container: true, direction: "row", justifyContent: "space-between" },
                React.createElement(PeekGrid, { item: true, alignSelf: "center" },
                    React.createElement(PeekStack, { direction: "column", spacing: theme.spacing(0.4) },
                        React.createElement(PeekTypography, { variant: "h3", display: "flex", alignItems: "center", fontWeight: "fontWeightMedium" }, title),
                        React.createElement(PeekTypography, { variant: "h6" }, subTitle))),
                actionIcon && (React.createElement(PeekGrid, { item: true },
                    React.createElement(PeekGrid, { container: true, spacing: 1, alignItems: "center" },
                        React.createElement(PeekGrid, { item: true }, actionIcon)))))),
        React.createElement(PeekAccordionDetails, { sx: Object.assign({ px: 0 }, (disabled && {
                pointerEvents: "none",
                opacity: 0.7,
            })) }, expanded && children)));
};
export default AccordionItem;
